import { HTMLAttributes } from 'react';
import { cx } from '@emotion/css';

interface HeaderItemBoxProps extends HTMLAttributes<HTMLSpanElement> {
  className?: string;
}

export const HeaderItemBox = (props: HeaderItemBoxProps) => {
  const { children, className, ...otherProps } = props;

  return (
    <span
      className={cx(
        'h-[20px] bg-[var(--fett-bg-elevated)] rounded-[2px] text-[var(--fett-text-secondary)] leading-[20px] px-2 text-nowrap',
        className,
      )}
      {...otherProps}
    >
      {children}
    </span>
  );
};
